// Static copy fallbacks — live values come from /api/content and /api/services.
export const FALLBACK_CONTENT = {
  business_name: "SY Exterior Cleaning",
  tagline: "Keeping South Yorkshire's Exteriors Spotless",
  phone: "07378114330",
  email: "mitchellsgutterservices@gmail.com",
  areas_text:
    "Based in South Yorkshire, covering Sheffield, Rotherham, Barnsley, Doncaster and surrounding areas for residential and commercial exterior maintenance.",
  map_image:
    "https://images.unsplash.com/photo-1544411047-c491e34a24e0?crop=entropy&cs=srgb&fm=jpg&q=85",
  facebook_url: "",
  instagram_url: "",
};

export const phoneHref = (phone) => `tel:+44${String(phone).replace(/^0/, "")}`;
export const whatsappHref = (phone) =>
  `https://wa.me/44${String(phone).replace(/^0/, "")}?text=${encodeURIComponent(
    "Hi SY Exterior Cleaning — I'd like a free quote please."
  )}`;

export const SERVICE_ICONS = {
  bin: "M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3",
  gutter: "M3 12h18M3 12l4 4M21 12l-4 4M8 4h8M12 4v8",
  house: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10",
  drive: "M4 19h16M7 19l3-14h4l3 14M10 12h4",
  patio: "M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z",
  roof: "M2 12l10-9 10 9M4 11v9h16v-9",
  window: "M3 3h18v18H3zM12 3v18M3 12h18",
  conservatory: "M2 21h20M4 21V12l8-7 8 7v9M12 5v16M8 14h8",
};

export const FAQS = [
  {
    q: "Do I need to be home for the clean?",
    a: "As long as we have rear access and an external water tap, you do not need to wait in.",
  },
  {
    q: "Are you fully insured for high-reach work?",
    a: "Yes, we are fully insured for all residential and commercial work, including high-reach cleaning.",
  },
  {
    q: "How do quotes work?",
    a: "We provide free, instant quotes via our online form, phone call or WhatsApp message.",
  },
  {
    q: "Which areas do you cover?",
    a: "All of South Yorkshire — Sheffield, Rotherham, Barnsley, Doncaster and surrounding areas.",
  },
  {
    q: "How do I pay?",
    a: "We confirm pricing before any work starts. Payment is taken on completion — no deposits needed for most domestic jobs.",
  },
];

export const MARQUEE_ITEMS = [
  "Driveway Pressure Washing",
  "Gutter Clearance & Wash",
  "Fascia & Soffits",
  "Roof Moss Removal",
  "Patio Restoration",
  "Window Cleaning",
  "Conservatory Valets",
  "Wheelie Bin Sanitising",
];

export const AREA_TILES = [
  "S1–S14 City & Suburbs",
  "S17–S20 South Sheffield",
  "Rotherham & Borders",
  "Dronfield & North East Derbys",
];
